import React from 'react';
import { resetLeaderPassword, setLeaderPassword, updateLeaderEmail } from '../../api/moduleApi';
import AccountSettings from '../../components/settings/AccountSettings';

const LeaderSettings = ({ user, selectedLeader, onUserUpdated }) => {
  const leaderId = selectedLeader?.account_id || user?.id;
  const currentEmail = selectedLeader?.email || user?.email;

  if (!leaderId) return <p className="text-red-600">No leader selected.</p>;

  return (
    <AccountSettings
      initialEmail={currentEmail || ''}
      onSaveEmail={(email) => updateLeaderEmail(leaderId, email)}
      onSavePassword={(password) => setLeaderPassword(leaderId, password)}
      onGenerateTempPassword={() => resetLeaderPassword(leaderId)}
      onUserUpdated={onUserUpdated}
      currentUser={user}
    />
  );
};

export default LeaderSettings;
